// extracted by mini-css-extract-plugin
export default {"container":"DataItem_container__V22k-","title":"DataItem_title__RAe5p","data":"DataItem_data__zyHuo"};